import { User, UcPackage, Order, SpinReward, SpinHistory, SpinResult, PopularityItem, SavedTargetId } from '../types';
import api from './api-client'; 

// todo: upd review endpoints and fix

// User endpoints
export const createOrUpdateUser = async (telegramId: number, telegramUsername?: string, referralCode?: string): Promise<User> => {
  const response = await api.post('/users/telegram', { telegramId, telegramUsername, referralCode });
  return response.data;
};

export const createOrUpdateTelegramUser = async (userData: { telegramId: string, telegramUsername?: string, referralCode?: string }): Promise<User> => {
  const response = await api.post('/users/telegram', userData);
  return response.data;
};

export const getUserByTelegramId = async (telegramId: number): Promise<User> => {
  const response = await api.get(`/users/telegram/${telegramId}`);
  return response.data;
};

export const checkReferralCode = async (code: string): Promise<{ valid: boolean; referrer?: string }> => {
  const response = await api.get(`/users/referral/${code}`);
  return response.data;
};

// UC Package endpoints
export const getUcPackages = async (): Promise<UcPackage[]> => {
  const response = await api.get('/packages');
  return response.data;
};

// Payment endpoints
export const createPayment = async (userId: string, packageId: string, amount: number, price: number): Promise<Order> => {
  const response = await api.post('/payments/create', { userId, packageId, amount, price });
  return response.data;
};

export const getUserOrders = async (userId: string): Promise<Order[]> => {
  const response = await api.get(`/payments/orders?telegramId=${userId}`);
  return response.data;
};

export const getAvailablePacks = async (): Promise<UcPackage[]> => {
  const response = await api.get('/payments/packs');
  return response.data;
};

export const activateReferralCode = async (telegramId: number, referralCode: string): Promise<{ success: boolean; message: string }> => {
  try {
    const response = await api.post('/users/activate-referral', {
      telegramId,
      referralCode
    });
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
    return {
      success: false,
      message: 'Failed to activate referral code'
    };
  }
};

// Spin endpoints
export const getSpinRewards = async (): Promise<SpinReward[]> => {
  const response = await api.get('/spin/rewards');
  return response.data;
};

export const getSpinRewardsShort = async (): Promise<SpinReward[]> => {
  const response = await api.get('/spin/rewards/short');
  return response.data;
};

export const getRandomReward = async (telegramId: string): Promise<SpinReward> => {
  const response = await api.get(`/spin/rewards/random/${telegramId}`);
  return response.data;
};

export const spin = async (userId: string): Promise<SpinResult> => {
  const response = await api.post(`/spin/${userId}`);
  return response.data;
};

export const getUserSpinHistory = async (telegramId: number): Promise<SpinHistory[]> => {
  const response = await api.get(`/spin/history/${telegramId}`);
  return response.data;
};

export const getUserDiscounts = async (telegramId: number): Promise<SpinHistory[]> => {
  const response = await api.get(`/spin/discounts/${telegramId}`);
  return response.data;
};

export const getSpinCost = async (): Promise<number> => {
  const response = await api.get('/spin/cost');
  return response.data.cost;
};

export const claimSpinReward = async (historyId: string, gameId?: string): Promise<{ success: boolean; message: string }> => {
  try {
    const response = await api.post('/spin/claim', { historyId, gameId });
    return response.data;
  } catch (error) {
    console.error('Error claiming spin reward:', error);
    throw error;
  }
};

export const createSpinHistory = async (telegramId: number, rewardId: string): Promise<SpinHistory> => {
  const response = await api.post('/spin/history/create', { telegramId, rewardId });
  return response.data;
};

export const spinWithReward = async (telegramId: number): Promise<{ spinHistory: SpinHistory, newBonusBalance: number }> => {
  const response = await api.post('/spin/spin-with-reward', { telegramId });
  return response.data;
};

// Discount activation methods - Common for both Version 2 and Version 3

// Start discount activation process
export const startDiscountActivation = async (historyId: string): Promise<any> => {
  try {
    const response = await api.post('/spin/start-discount-activation', { historyId });
    return response.data;
  } catch (error) {
    console.error('Error starting discount activation:', error);
    throw error;
  }
};

// Cancel discount activation process
export const cancelDiscountActivation = async (historyId: string): Promise<any> => {
  try {
    const response = await api.post('/spin/cancel-discount-activation', { historyId });
    return response.data;
  } catch (error) {
    console.error('Error canceling discount activation:', error);
    throw error;
  }
};

// Get active discounts for a user
export const getActiveDiscounts = async (userId: string): Promise<any> => {
  try {
    const response = await api.get(`/spin/active-discounts/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting active discounts:', error);
    throw error;
  }
};

// Get available discounts for a user (primarily for Version 2 - Shop Page Direct)
export const getAvailableDiscounts = async (userId: string): Promise<any> => {
  try {
    const response = await api.get(`/spin/available-discounts/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting available discounts:', error);
    throw error;
  }
};

// Apply discount to an order
export const applyDiscount = async (historyId: string, orderId: string): Promise<any> => {
  try {
    const response = await api.post('/spin/apply-discount', { historyId, orderId });
    return response.data;
  } catch (error) {
    console.error('Error applying discount:', error);
    throw error;
  }
};

// Bot state endpoint
export const getBotState = async (): Promise<{ isActive: boolean; maintenanceMessage: string }> => {
  try {
    const response = await api.get('/bot-state');
    return response.data;
  } catch (error) {
    console.error('Error fetching bot state:', error);
    // Default to active in case of error to avoid showing maintenance page unnecessarily
    return { isActive: true, maintenanceMessage: 'Сервис временно недоступен.' };
  }
};

// Popularity Store endpoints
export const getPopularityItems = async (): Promise<PopularityItem[]> => {
  const response = await api.get('/popularity/items');
  return response.data;
};

export const getPopularityItemById = async (id: string): Promise<PopularityItem> => {
  const response = await api.get(`/popularity/items/${id}`);
  return response.data;
};

export const getSavedTargetIds = async (): Promise<SavedTargetId[]> => {
  const response = await api.get('/popularity/saved-ids');
  return response.data;
};

export const saveTargetId = async (targetId: string): Promise<SavedTargetId> => {
  const response = await api.post('/popularity/saved-ids', { targetId });
  return response.data;
};

export const deleteSavedTargetId = async (id: string): Promise<{ success: boolean }> => {
  const response = await api.delete(`/popularity/saved-ids/${id}`);
  return response.data;
};

export default api;
